export interface IAlert {
    alertId: string;
    title: string;
    body: string;
    alertType: string;
    expiryDate: Date;
}

// Note: IAlertResponse is the data returned from service, uses CAPITALISED property names and Expiry instead of ExpiryDate.

export interface IAlertResponse {
    AlertId: string;
    Title: string;
    Body: string;
    AlertType: string;
    Expiry: Date;
}

export const isIAlertResponse = (obj: object): obj is IAlertResponse => {

    // Check all properties exist.
    if ((obj as IAlertResponse).AlertId === undefined) { return false; };
    if ((obj as IAlertResponse).Title === undefined) { return false; };
    if ((obj as IAlertResponse).Body === undefined) { return false; };
    if ((obj as IAlertResponse).AlertType === undefined) { return false; };
    if ((obj as IAlertResponse).Expiry === undefined) { return false; };

    return true;
};
